import type { IOrganizationGroupListItem } from "@/api/organization-groups";
import { formatDate } from "@/utils";
import type { ColumnDef } from "@tanstack/react-table";
import { Link } from "react-router";

export const memberLabel = (count: number) =>
    `${count} ${count === 1 ? "member" : "members"}`;

export const columns: ColumnDef<IOrganizationGroupListItem>[] = [
    {
        accessorKey: "name",
        header: "Name",
        meta: { cellClassName: "min-w-[12rem] max-w-[24rem]" },
        cell: ({ row }) => (
            <div className="min-w-0">
                <Link
                    to={`/admin/organization-groups/${row.original.id}/details`}
                    className="block truncate font-medium hover:underline"
                >
                    {row.original.name}
                </Link>
                <span className="text-muted-foreground mt-0.5 block text-xs sm:hidden">
                    {memberLabel(row.original.member_count)}
                </span>
            </div>
        ),
    },
    {
        id: "owner",
        header: "Owner",
        cell: ({ row }) => (
            <span className="truncate">
                {row.original.owner_organization.name}
            </span>
        ),
    },
    {
        accessorKey: "member_count",
        header: "Members",
        meta: { cellClassName: "hidden sm:table-cell" },
        cell: ({ row }) => (
            <span className="tabular-nums">{row.original.member_count}</span>
        ),
    },
    {
        accessorKey: "created_at",
        header: "Created",
        meta: { cellClassName: "hidden sm:table-cell" },
        cell: ({ row }) => formatDate(row.original.created_at),
    },
];
